let baseUrl;

if (process.env.NODE_ENV !== 'production') {
  // baseUrl = 'https://xapi.shuimujiaju.com'
  baseUrl = 'http://localhost:8080/';
  // baseUrl = '/api'
} else {
  baseUrl = 'https://xapi.shuimujiaju.com'
  // baseUrl = 'http://jike.yxboot.com/api'
}

let projectKey = 'xgj.jikejiazhuang.com-';
let imgUrl = 'http://img.shuimujiaju.com/';

export {
  baseUrl,
  projectKey,
  imgUrl,
}
